// Ids the latest search so slower, older responses don't overwrite it
let latestSearchId = 0;

const defaultState = () => ({
  // The search the results came from, as the view serializes its filter
  filterKey: null,
  loaded: false,
  loading: false,
  page: 1,
  perPage: 30,
  records: [],
  selectedTags: [],
  tagGroups: [],
  total: 0,
  unlockedTotal: 0,
});

const getters = {
  enabled: (state, getters, rootState, rootGetters) => rootGetters['user/featureEnabled']('featureTagSearch'),
  filterKey: state => state.filterKey,
  loaded: state => state.loaded,
  loading: state => state.loading,
  page: state => state.page,
  perPage: state => state.perPage,
  records: state => state.records,
  selectedTags: state => state.selectedTags,
  tagGroups: state => state.tagGroups,
  total: state => state.total,
  totalPages: state => Math.max(Math.ceil(state.total / (state.perPage || 1)), 1),
  unlockedTotal: state => state.unlockedTotal,
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setResults(state, { data, filterKey = null }) {
    state.filterKey = filterKey;
    state.loaded = true;
    state.page = data.page || 1;
    state.perPage = data.perPage || state.perPage;
    state.records = data.records || [];
    state.selectedTags = data.selectedTags || [];
    state.tagGroups = data.tagGroups || [];
    state.total = data.total || 0;
    state.unlockedTotal = data.unlockedTotal || 0;
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  search({ commit, rootGetters }, { q = '', tags = [], page = 1 } = {}) {
    const searchId = ++latestSearchId;
    const params = { page };
    if (q) params.q = q;
    if (tags.length) params.tags = tags;

    commit('setLoading', true);
    return rootGetters['session/ajax'].get('/tag_searches', { params }).then(response => {
      if (searchId === latestSearchId) {
        commit('setResults', { data: response.data, filterKey: JSON.stringify({ q, tags, page }) });
      }
      return response.data;
    }).finally(() => {
      if (searchId === latestSearchId) commit('setLoading', false);
    });
  },
  // Builds a quiz from a random sample of the unlocked matches and resolves to its category
  async createQuiz({ commit, dispatch, rootGetters }, { q = '', tags = [], limit, name }) {
    const body = { q, tags, limit };
    if (name) body.name = name;

    const { data } = await rootGetters['session/ajax'].post('/tag_searches/quiz', body);
    const categories = data.records || data.categories;
    commit('categories/setCategories', categories, { root: true });
    await dispatch('session/loadUser', null, { root: true });
    return categories[0];
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
